"use client";
import React, { useState, useEffect } from "react";


export const TableOfContents = ({ sections }: { sections: { id: string; title: string }[] }) => {
    const [activeId, setActiveId] = useState<string>("");

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setActiveId(entry.target.id);
                    }
                });
            },
            { rootMargin: "-20% 0px -35% 0px" }
        );

        sections.forEach((section) => {
            const element = document.getElementById(section.id);
            if (element) observer.observe(element);
        });

        return () => observer.disconnect();
    }, [sections]);

    return (
        <nav className="space-y-1">
            {sections.map((section) => (
                <a
                    key={section.id}
                    href={`#${section.id}`}
                    className={`block text-sm py-1.5 px-3 border-l-2 transition-all ${activeId === section.id
                        ? "border-primary text-primary font-medium bg-primary/5 rounded-r"
                        : "border-transparent text-secondary-text hover:text-primary-text hover:border-border"
                        }`}
                >
                    {section.title}
                </a>
            ))}
        </nav>
    );
};
